import React, { useEffect, useReducer, useContext } from 'react';
import PropTypes from 'prop-types';

// Reducers
import appReducer from './appReducer';
import useStorage from '../utils/hooks/useStorage';

const AppStateContext = React.createContext();
const AppDispatchContext = React.createContext();

const initStore = {
  user: null,
  establishment: null,
  adminType: null,

  activeTab: 0,
  notifications: [],
  modal: null,
  modalQueryLoading: null,
};

function AppProvider({ children }) {
  const { getItem, setItem } = useStorage();

  const [state, dispatch] = useReducer(
    (st, act) => appReducer(st, act, setItem),
    initStore,
  );

  const populateFromStorage = (key, reducerType) => {
    if (!state[key]) {
      const stored = getItem(key);
      if (stored) {
        dispatch({ type: reducerType, payload: stored });
      }
    }
  };

  useEffect(() => {
    // populate with storage
    populateFromStorage('user', 'SET_USER');
    populateFromStorage('adminType', 'SET_ADMIN_TYPE');
  }, []);

  useEffect(() => {
    if (!state.user && getItem('user')) populateFromStorage('user', 'SET_USER');
  }, [state.user]);

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  );
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const useAppContext = () => [useContext(AppStateContext), useContext(AppDispatchContext)];

export {
  AppProvider,
  AppStateContext,
  AppDispatchContext,
  useAppContext,
};
